import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import InfiniteScroll from '../../commons/InfiniteScroll';
import UserCard from '../../commons/UserCard';
import {
  FOLLOWINGS_REQUESTED,
  FOLLOWINGS_RETRIEVED,
  FOLLOWINGS_FAILED
} from '../../redux/actions/types';
import { getFollowings } from '../../redux/actions/social';
import RTVSwitch from '../../commons/RTVSwitch';
import LoadingGif from '../../images/Loading.gif';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  followingsList: {
    padding: theme.spacing(1),
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  loadingSection: {
    padding: theme.spacing(2),
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  filterSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& > p': {
      marginLeft: '4px',
      fontWeight: 500
    }
  }
});

class Followings extends Component {
  constructor(props) {
    super();
    this.state = {
      reloadCount: 0,
      followings: [],
      loadingFollowings: false,
      hasMoreFollowings: false,
      filterPromo: false
    };
  }

  componentDidMount() {
    this.props.getFollowings(this.props.user);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.reloadCount !== this.state.reloadCount) {
      this.setState(
        {
          followings: []
        },
        () => {
          this.props.getFollowings(this.props.user, this.state.filterPromo);
        }
      );
    }

    if (prevState.filterPromo !== this.state.filterPromo) {
      this.setState(state => ({
        ...state,
        reloadCount: state.reloadCount + 1
      }));
    }

    if (prevProps.followingsStatus !== this.props.followingsStatus) {
      if (this.props.followingsStatus === FOLLOWINGS_REQUESTED) {
        this.setState({ loadingFollowings: true });
      }
      if (this.props.followingsStatus === FOLLOWINGS_RETRIEVED) {
        this.setState(state => ({
          loadingFollowings: false,
          followings: [...state.followings, ...this.props.followings],
          hasMoreFollowings: this.props.followings.length === 10
        }));
      }
      if (this.props.followingsStatus === FOLLOWINGS_FAILED) {
        this.setState({ loadingFollowings: false });
      }
    }
  }

  loadMore = page => {
    this.props.getFollowings(this.props.user, this.state.filterPromo, page);
  };

  render() {
    const { classes } = this.props;

    return (
      <>
        {this.props.social && (
          <div className={classes.filterSection}>
            <RTVSwitch
              disabled={this.state.loadingFollowings}
              checked={this.state.filterPromo}
              onClick={() =>
                this.setState(state => ({
                  ...state,
                  filterPromo: !state.filterPromo
                }))
              }
            />
            <Typography>
              {this.props.t('promotionDressers', { ns: 'social' })}
            </Typography>
          </div>
        )}
        {this.state.followings.length === 0 && this.state.loadingFollowings && (
          <div className={classes.loadingSection}>
            <img src={LoadingGif} alt="loading" />
            <Typography color="primary">
              {this.props.t('loadingDressers', { ns: 'dresser' })}
            </Typography>
          </div>
        )}
        {this.state.followings.length > 0 && (
          <>
            <div className={classes.followingsList}>
              <InfiniteScroll
                loadMore={this.loadMore}
                pageStart={2}
                pageSize={1}
                mode={this.state.reloadCount}
                hasMore={this.state.hasMoreFollowings}
                loading={this.state.loadingFollowings}
                threshold={1000}
              >
                {this.state.followings.map(following => (
                  <UserCard
                    noProductsFetch
                    key={following.id}
                    noProductsAllowed
                    user={following}
                  />
                ))}
              </InfiniteScroll>
            </div>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  followings: state.social.followings,
  followingsStatus: state.social.status
});

const mapDispatchToProps = dispatch => ({
  getFollowings: (user, filterPromo, page) =>
    dispatch(getFollowings(user, filterPromo, page))
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Followings))
);
